




import Vue from "vue";
import FormField, { FormFieldType } from "@/meta/FormField";

export default Vue.extend({
  name: "EntityFormField",
  props: {
    field: {
      type: Object as () => FormField,
      required: true,
    },
    value: {
      type: [String, Object, Number, Boolean, Date, Array],
      required: false,
    },
    item: {
      type: Object,
      required: true,
    },
  },
  data: () => {
    return {};
  },
  computed: {
    fieldComponent(): string {
      let result = "v-textarea";
      switch (this.field.type) {
        case FormFieldType.TEXT:
        case FormFieldType.NUMBER:
          result = "v-text-field";
          break;
        case FormFieldType.SELECT:
          result = "v-select";
          break;
        case FormFieldType.COMBO:
          result = "v-autocomplete";
          break;
        case FormFieldType.TAGS:
          result = "v-combobox";
          break;
        default:
          break;
      }
      return result;
    },
    fieldType(): string {
      let result = "text";
      if (this.field.type === FormFieldType.NUMBER) {
        result = "number";
      }
      return result;
    },
    isMultiple(): boolean {
      let result = false;
      switch (this.field.type) {
        case FormFieldType.COMBO:
        case FormFieldType.TAGS:
          result = true;
          break;
        default:
          break;
      }
      return result;
    },
  },
  methods: {},
});
